import React, { useEffect } from "react";

import Text from "antd/lib/typography/Text";
import { useParams } from "react-router-dom";
import ItemStockInformation from "./ItemStockInformation";
import AssociateSection from "../../components/AssociateSection";
import ItemImageDisplay from "./itemImageDisplay";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import ItemSalesOrderSummary from "./ItemSalesOrderSummary";
import ItemSkuQrCode from "./ItemSkuQrCode";

function ItemOverviewPage(props) {
  const { item_id } = useParams();

  return (
    <>
      <div className="border-[1px] border-gray-200 rounded-lg p-4 @container">
        {/* BEANS SECTION */}

        <div className="w-full @xl:grid @xl:grid-cols-5 @xl:gap-4">
          <div className="mt-3 @xl:col-span-2 ">
            <div className="text-gray-600 font-bold text-xl">
              {props.itemDetails.item_name}{" "}
            </div>
            <div className="mt-4 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Item Id</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_id}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Type</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_type_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Category</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_category_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Unit</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_unit_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Group</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_group_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Dimension</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_dimension_unit_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">SKU</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_sku}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">is Returnable</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_returnable_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Type</div>
              <div className="text-xs font-bold">
                {props.itemDetails.item_variety_name}
              </div>
            </div>
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2">Type</div>
              <div className="text-xs font-bold">
                {props.itemDetails?.product_sharing_status_id === 1
                  ? " GrooPool Item "
                  : "Not GrooPool"}
              </div>
            </div>

            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2"> Stock</div>
              <div
                className={`text-xs font-bold px-2 py-1 rounded ${
                  !props.itemDetails?.item_stock_out
                    ? "bg-green-200"
                    : "bg-red-200"
                }`}
              >
                {props.itemDetails.item_stock_out ? "Out of Stock" : "In Stock"}
              </div>
            </div>

            {/* Flash sales */}
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2"> Flash Sales</div>
              <div
                className={`text-xs font-bold px-2 py-1 rounded ${
                  props.itemDetails?.flash_sales_status_id === 1
                    ? "bg-green-200"
                    : "bg-red-200"
                }`}
              >
                {props.itemDetails.flash_sales_status_id === 1 ? "Yes" : "No"}
              </div>
            </div>

            {/* Top Deals */}
            <div className="mt-1 flex fle-col items-center text-gray-700">
              <div className="w-[120px] text-sm mr-2"> Top Deals</div>
              <div
                className={`text-xs font-bold px-2 py-1 rounded ${
                  props.itemDetails?.top_deal_status_id === 1
                    ? "bg-green-200"
                    : "bg-red-200"
                }`}
              >
                {props.itemDetails.top_deal_status_id === 1 ? "Yes" : "No"}
              </div>
            </div>

            {/* SKU QR CODE */}
            <div className="mt-4 inline-flex flex-col items-center rounded-md border border-gray-200 bg-white p-3">
              <div className="mb-2 text-sm font-medium text-gray-600">Item QR Code</div>
              <ItemSkuQrCode sku={props.itemDetails?.item_sku} name={props.itemDetails?.item_name} size={160} />
            </div>
          </div>

          <div className="mt-3 @xl:col-span-3">
            <ItemImageDisplay
              key={props.imageList?.[0]?.image_url ?? 'no-image'}
              imageList={props.imageList}
            />
          </div>
        </div>
      </div>
      {/* PURCHASE SECTION  */}
      <div className="mt-4 p-4 border-[1px] border-gray-200 bg-white rounded-md">
        <div className="grid grid-cols-1 @md:grid-cols-2 gap-4 ">
          <div className="flex-1">
            <h3 className="mt-3 text-base font-bold text-gray-700">
              Purchase Information
            </h3>
            <div className="mt-3 text-xs flex flex-row items-center">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Cost Price
              </div>
              <div className="text-sm font-bold text-gray-600">
                <Text>&#8358;</Text>{" "}
                {formatCustomNumber(props.itemDetails.cost_rate)}
              </div>
            </div>
            <div className="mt-1 text-xs flex flex-row items-center ">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Market Price
              </div>
              <div className="text-sm font-bold text-gray-600">
                <Text>&#8358;</Text>{" "}
                {formatCustomNumber(props.itemDetails.market_rate)}
              </div>
            </div>
            <div className="mt-1 text-xs flex flex-row items-center">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Account{" "}
              </div>
              <div className="text-sm font-bold text-gray-600">
                {props.itemDetails.purchase_account_name}
              </div>
            </div>
            <div className="mt-1 text-xs flex flex-row items-center ">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Description
              </div>
              <div className="text-sm font-bold text-gray-600">
                {props.itemDetails.purchase_description}{" "}
              </div>
            </div>
          </div>
          <div className="flex-1">
            <h3 className="mt-3 text-base font-bold text-gray-700">
              Sales Information
            </h3>
            <div className="mt-3 text-xs flex flex-row items-center ">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Grocedy Price{" "}
              </div>
              <div className="text-sm font-bold text-gray-600">
                <Text>&#8358;</Text>{" "}
                {formatCustomNumber(props.itemDetails.sales_rate)}
              </div>
            </div>
            <div className="mt-1 text-xs flex flex-row items-center ">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Account{" "}
              </div>
              <div className="text-sm font-bold text-gray-600">
                {props.itemDetails.sales_accounts_name}{" "}
              </div>
            </div>
            <div className="mt-1 text-xs flex flex-row items-center">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Description
              </div>
              <div className="text-sm font-bold text-gray-600">
                {props.itemDetails.sales_description}{" "}
              </div>
            </div>
            <div className="mt-1 text-xs flex flex-row items-center">
              <div className="w-[110px] font-medium text-gray-600 mr-2">
                Re order level
              </div>
              <div className="text-sm font-bold text-gray-600">
                {props.itemDetails.reorder_quantity}{" "}
              </div>
            </div>
          </div>
        </div>

        {/* ASSOCIATE */}
        {props?.itemDetails?.item_variety_id === 2 ? (
          <AssociateSection Item_Id={item_id}></AssociateSection>
        ) : null}
      </div>

      <div className=" mt-4">
        <ItemStockInformation
          Item_Id={props.itemDetails.item_id}
        ></ItemStockInformation>
      </div>

      <div className=" mt-4">
        <ItemSalesOrderSummary
          Item_Id={props.itemDetails.item_id}
        ></ItemSalesOrderSummary>
      </div>
    </>
  );
}

export default ItemOverviewPage;
